import React from 'react';
import PropTypes from 'prop-types';
import { ScaleLoader } from 'react-spinners';
import { withTranslation } from 'react-i18next';
import { RowContent, RowHeader } from './TableRow';

class Table extends React.PureComponent {
  tableRef = React.createRef();

  onClickRow = (e, item) => {
    const { onClickRow } = this.props;
    if (onClickRow) {
      onClickRow(e, item);
    }
  };

  render() {
    const {
      fixedHeader,
      columns,
      data,
      rowClass,
      noDataMessage,
      getRowClass,
      sorted,
      onSort,
      tableClass,
      nullIsLoading,
      isLoading,
      indexParent, // Using when map & render table
      onCheckAll,
      t,
      isFixedHeaderTable,
      ...rest
    } = this.props;
    return (
      <div
        className={`table-responsive mt-15 ${isFixedHeaderTable ? 'sticky-header' : ''} table-form ${tableClass} ${
          fixedHeader ? 'tableFixHead' : ''
        }`}
        ref={this.tableRef}
      >
        <table className="table center-aligned-table mb-0">
          <thead>
            <RowHeader
              columns={columns}
              sorted={sorted}
              onSort={onSort}
              isLoading={isLoading}
              onCheckAll={onCheckAll}
              t={t}
            />
          </thead>
          <tbody>
            {!isLoading &&
              data &&
              data.map((item, idx) => (
                <RowContent
                  key={`row-${idx}`}
                  columns={columns}
                  item={item}
                  onClickRow={this.onClickRow}
                  className={rowClass}
                  getRowClass={getRowClass}
                  indexParent={indexParent}
                  indexItem={idx}
                  {...rest}
                />
              ))}
            {(isLoading || !data || data.length === 0) && (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  {!isLoading && !nullIsLoading && <span>{t(noDataMessage)}</span>}
                  {(isLoading || ((!data || data.length === 0) && nullIsLoading)) && (
                    <ScaleLoader loading size={100} color="#28a745" />
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  sorted: PropTypes.object,
  data: PropTypes.array.isRequired,
  rowClass: PropTypes.string,
  tableClass: PropTypes.string,
  noDataMessage: PropTypes.string,
  nullIsLoading: PropTypes.bool,
  isLoading: PropTypes.bool,
  getRowClass: PropTypes.func,
  onCheckAll: PropTypes.func,
  onSort: PropTypes.func,
  fixedHeader: PropTypes.bool,
  isFixedHeaderTable: PropTypes.bool,
  indexParent: PropTypes.number,
};

Table.defaultProps = {
  columns: [],
  sorted: {},
  data: [],
  rowClass: '',
  tableClass: '',
  getRowClass: null,
  isLoading: false,
  nullIsLoading: false,
  onSort: null,
  noDataMessage: 'message.noRecord',
  fixedHeader: false,
  isFixedHeaderTable: false,
  indexParent: 0,
  onCheckAll: () => {},
};

export default withTranslation('common')(Table);
